module.exports = __webpack_public_path__ + "static/media/for-sure.13620510.mp3";